"use client";

import { Card, CardContent } from "@heroui/react";
import { Button } from "@heroui/react";
import { useTranslations } from "next-intl";

export default function LoginPage() {
  const t = useTranslations("auth login");

  const handleLogin = () => {
    // redirect to your SSO auth route
    window.location.href = "/auth/sign-in";
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full dark:bg-secondary max-w-md rounded-3xl p-8 text-center shadow-none">
        <CardContent className="flex flex-col items-center gap-6">
          <h1 className="text-3xl font-bold">{t("title")}</h1>

          <p className="text-md text-gray-600">{t("description")}</p>

          <Button
            className="bg-primary-700 hover:bg-primary-800  w-full rounded-full font-semibold"
            size="lg"
            onPress={handleLogin}
          >
            {t("continue with sso")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
